import {
  Dialog,
  DialogContent,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { AccountCircle, Close, Logout } from '@mui/icons-material';
import {
  Login_Form,
  Recover_Form,
  Register_Form,
} from 'components/Forms';
import { onLogout } from '@services';
import { useAppContext } from '@containers';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import React, { useEffect, useState } from 'react';
const Login = ({ className }) => {
  const { t } = useTranslation();
  const { push } = useRouter();
  const { user, setLogout, setReconciliation, onShowLoginDialog } =
    useAppContext();

  const [open, setOpen] = useState(false);
  const [type, setType] = useState('sign_in');
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const onClickProfileIcon = () => push('/user/');
  const onClickLogout = async (e) => {
    try {
      await onLogout();
      setLogout();
      setReconciliation(false);
      push('/');
    } catch (error) {
      console.error('onClickLogout', error);
    }
  };

  const handleLogin = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
    onShowLoginDialog(false);
  };
  useEffect(() => {
    if (!open) {
      const timeoutId = setTimeout(() => {
        setType('sign_in');
      }, [1000]);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [open]);

  useEffect(() => {
    if (user?.showLoginDialog) {
      setOpen(true);
      setType('sign_in');
    }
  }, [user?.showLoginDialog]);

  const formByType = () => {
    switch (type) {
      case 'sign_in':
        return (
          <Login_Form
            onSignUp={() => setType('sign_up')}
            onRecover={() => setType('forgot_password')}
            onClose={handleClose}
          />
        );
      case 'sign_up':
        return <Register_Form onClose={handleClose} />;
      case 'forgot_password':
        return <Recover_Form onClose={handleClose} />;
      default:
        break;
    }
  };

  return (
    <>
      <div
        className={classNames(
          className,
          ' max-w-full inline-block',
        )}
      >
        {user?.logged ? (
          <>
            <Tooltip title={t('pages.personal_area.title')}>
              <IconButton onClick={handleClick}>
                <AccountCircle className="fill-primary-950" />
              </IconButton>
            </Tooltip>
          </>
        ) : (
          <>
            <Tooltip title={t('login.sign_in')}>
              <IconButton onClick={handleLogin}>
                <PersonOutlineOutlinedIcon className="fill-primary-950" />{' '}
              </IconButton>
            </Tooltip>
          </>
        )}
      </div>
      <Menu
        open={openMenu}
        id="locale-menu"
        anchorEl={anchorEl}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'locale-button',
        }}
      >
        <MenuItem
          className="md:space-x-1"
          onClick={() => {
            onClickProfileIcon();
            handleCloseMenu();
          }}
        >
          <ListItemIcon>
            <PersonOutlineOutlinedIcon className="text-primary" />
          </ListItemIcon>
          <span className="font-bilo text-base">
            Area personale
          </span>
        </MenuItem>

        <MenuItem
          className="md:space-x-1"
          onClick={() => {
            // dispatch(setReductionsIDsReducer([]));
            onClickLogout();
            handleCloseMenu();
          }}
        >
          <ListItemIcon>
            <Logout className="text-primary" />
          </ListItemIcon>
          <span className="font-bilo text-base">Log out</span>
        </MenuItem>
      </Menu>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={'xs'}
        fullWidth
      >
        <div className="text-center p-4">
          <span className="body text-primary-950">
            {t(`login.${type}`)}
          </span>
          <IconButton
            className="absolute top-[10px] right-3"
            onClick={handleClose}
          >
            <Close fontSize="small" className="text-primary-950" />
          </IconButton>
        </div>
        <DialogContent>{formByType()}</DialogContent>
      </Dialog>
    </>
  );
};

export default Login;
